export interface EnrichedUserDetailsFormModel {
  emailAddress: string;
  assignedEnrichedUserDetails: string[];
}
